import AboutHeroSection from "../components/AboutHeroSection";
import Introduction from "../components/Introduction";
import MissionVisionValues from "../components/MissionVissionValues";

function About(){
    return(
        <>
            <AboutHeroSection/>
            <Introduction/>
            <MissionVisionValues/>
        </>
    );
}

export default About;